import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import * as Redux from 'redux'
import { IRootStates } from '../../../models/store.model'
import AuthAction from '../../../store/auth/auth.action'
import AuthLayout from '../AuthLayout'

interface ICreateProfileLayout {
    children: React.ReactNode
    user?: any
}

function CreateProfileLayout(props: ICreateProfileLayout) {
    // core section
    const history = useHistory()
    const { children, user } = props
    const ac = new AbortController()

    // hooks section
    useEffect(() => {
        if (user?.role) {
            history.push('/firearms')
        }
        return () => {
            ac.abort()
        }
    }, [user])

    return (
        <>
            <AuthLayout>
                <div className="create-profile-layout">
                    <div
                        className="text-left arrow-back"
                        style={{ marginBottom: '-12px' }}
                    >
                        <span
                            style={{
                                marginLeft: '-18px',
                            }}
                            onClick={() => history.goBack()}
                        >
                            <img
                                className="mr-2"
                                src={require('@Images/arrow_back.png').default}
                                alt=""
                            />
                        </span>
                        Back
                    </div>
                    <div className="auth-headline">CREATE PROFILE</div>
                    <hr className="auth-hr" style={{ marginTop: '5px' }} />
                    {children}
                </div>
            </AuthLayout>
        </>
    )
}

const mapStateToProps = (state: IRootStates) => {
    const { user } = state.auth
    return { user }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    const { setRegister } = AuthAction
    return {
        setRegister: (registerData: any) =>
            dispatch(setRegister(registerData) as any),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateProfileLayout)
